"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _FtoIcon = createIcon({
  displayName: "_FtoIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m250 85 55-55h-110zm0 140 55-55h-110zm-140-140 55-55h-110zm280 0 55-55h-110zm-210-52.3 55 55h-110zm140 0 55 55h-110zm-140 122.3 55-55h-110zm140 0 55-55h-110zm-70-52.3 55 55h-110z"
        fill="currentColor"
      />
      <path
        d="m415 250 55 55v-110zm-140 0 55 55v-110zm140-140 55 55v-110zm0 280 55 55v-110zm52.3-210-55 55v-110zm0 140-55 55v-110zm-122.3-140 55 55v-110zm0 140 55 55v-110zm52.3-70-55 55v-110z"
        fill="currentColor"
      />
      <path
        d="m85 250-55-55v110zm140 0-55-55v110zm-140 140-55-55v110zm0-280-55-55v110zm-52.3 210 55-55v110zm0-140 55-55v110zm122.3 140-55-55v110zm0-140-55-55v110zm-52.3 70 55-55v110z"
        fill="currentColor"
      />
      <path
        d="m250 415 55 55h-110zm0-140 55 55h-110zm-140 140 55 55h-110zm280 0 55 55h-110zm-210 52.3 55-55h-110zm140 0 55-55h-110zm-140-122.3 55 55h-110zm140 0 55 55h-110zm-70 52.3 55-55h-110z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _FtoIcon;
